import { useCompany } from "../context/CompanyContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";
import { Buildings } from "@phosphor-icons/react";

export default function CompanySwitcher() {
  const { companies, activeCompanyId, setCompany } = useCompany();

  if (!companies.length) {
    return <div className="text-xs text-[#525252] italic">No companies</div>;
  }

  return (
    <Select value={activeCompanyId || undefined} onValueChange={setCompany}>
      <SelectTrigger
        data-testid="company-switcher"
        className="w-full bg-white border border-[#E5E5E5] rounded-none focus:ring-0 focus:border-[#002FA7] h-auto py-2.5"
      >
        <SelectValue placeholder="Select company" />
      </SelectTrigger>
      <SelectContent className="rounded-none">
        {companies.map((c) => (
          <SelectItem
            key={c.id}
            value={c.id}
            data-testid={`company-option-${c.id}`}
            className="rounded-none cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <Buildings size={14} weight="duotone" className="flex-shrink-0" />
              <span className="font-heading font-medium truncate">{c.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
